import React from 'react';

const vat0Columns = [
    {
        key: 'K9',
        title: <>Shitjet e liruara pa t&euml; drejt&euml; kreditimi</>,
        box: '9',
    },
    {
        key: 'K10a',
        title: <>Shitjet e sh&euml;rbimeve jasht&euml; vendit</>,
        box: '10a',
    },
    {
        key: 'K10b',
        title: <>Shitjet e brenda vendit me ngarkes&euml; t&euml; kund&euml;rt t&euml; TVSH-t&euml;</>,
        box: '10b',
    },
    {
        key: 'K10c',
        title: <>Shitjet e liruara me t&euml; drejt&euml; kreditimi</>,
        box: '10c',
    },
    {
        key: 'K10',
        title: <>Totali i shitjeve t&euml; liruara me t&euml; drejt&euml; kreditimi</>,
        box: '10',
    },
    {
        key: 'K11',
        title: <>Eksportet</>,
        box: '11',
    },
];

const vat18Columns = [
    {
        key: 'K12',
        title: <>Shitjet e tatueshme me norm&euml;n 18%</>,
        box: '12',
    },
    {
        key: 'K16',
        title: <>debitore e l&euml;shuar, nota kreditore</>,
        box: '16',
    },
    {
        key: 'K20',
        title: <>borxhit t&euml; keq e pranuar, inaksimi I.B.K.</>,
        box: '20',
    },
    {
        key: 'K24',
        title: <>met p&euml;r t&euml; rritur TVSH-n&euml; me norm&euml;</>,
        box: '24',
    },
    {
        key: 'K28',
        title: <>q&euml; i n&euml;nshtrohen ngarkes&euml;s s&euml;</>,
        box: '28',
    },
];

const vat8Columns = [
    {
        key: 'K14',
        title: <>Shitjet e tatueshme me norm&euml;n 8%</>,
        box: '14',
    },
    {
        key: 'K18',
        title: <>debitore e l&euml;shuar, nota kreditore</>,
        box: '18',
    },
    {
        key: 'K22',
        title: <>borxhit t&euml; keq e pranuar, inaksimi I.B.K.</>,
        box: '22',
    },
    {
        key: 'K26',
        title: <>met p&euml;r t&euml; rritur TVSH-n&euml; me norm&euml;</>,
        box: '26',
    },
];

const cellStyle = { border: '1.0pt solid #000', padding: 0, marggin: 0 };

const AtkSaleBookHeader = ({ reference }) => {
    return (
        <tbody>
            <tr height="34" style={{ textAlign: 'center', lineHeight: 1, fontSize: '10pt', fontFamily: 'Arial', fontWeight: 'bold' }}>
                <td height="34" width="39.20" style={cellStyle} rowSpan={2}>Nr</td>
                <td width="192" style={cellStyle} colSpan={2}>Fatura</td>
                <td width="355.93" style={cellStyle} colSpan={3}>Bler&euml;si</td>
                <td width={vat0Columns.length * 80} style={cellStyle} colSpan={vat0Columns.length}>Shitjet e liruara nga TVSH</td>
                <td width={vat18Columns.length * 80} style={cellStyle} colSpan={vat18Columns.length + 1}>Shitjet e tatueshme me norm&euml;n 18%</td>
                <td width={vat8Columns.length * 80} style={cellStyle} colSpan={vat8Columns.length + 1}>Shitjet e tatueshme me norm&euml;n 8%</td>
                <td width="95.93" rowSpan={2} style={{ ...cellStyle, background: '#BFBFBF' }}>Totali i TVSH-se se zbritshme me 18% dhe 8%</td>
            </tr>
            <tr style={{ height: '97px', textAlign: 'center', fontSize: '9pt', fontFamily: 'Arial' }}>
                <td style={cellStyle}>Data</td>
                <td style={cellStyle}>{reference ? 'Referenca' : 'Numri i fatur&euml;s'}</td>
                <td style={cellStyle}>Emri i bler&euml;sit</td>
                <td style={cellStyle}>Numri fiskal i bler&euml;sit</td>
                <td style={cellStyle}>Numri i TVSH-se se bler&euml;sit</td>
                {vat0Columns.map(column => (
                    <td key={column.key} style={cellStyle}>{column.title}</td>
                ))}
                {vat18Columns.map(column => (
                    <td key={column.key} style={cellStyle}>{column.title}</td>
                ))}
                <td style={{ ...cellStyle, backgroundColor: '#CFFFD3' }}>TVSH-se se zbritshme me 18%</td>
                {vat8Columns.map(column => (
                    <td key={column.key} style={cellStyle}>{column.title}</td>
                ))}
                <td style={cellStyle}>TVSH-se se llogaritur me norm&euml;n</td>
            </tr>
            <tr style={{ color: 'black', textAlign: 'center', fontSize: '9pt', fontFamily: 'Arial' }}>
                <td style={{ ...cellStyle, background: '#BFBFBF' }} colSpan={6}>Numri i kutise ne deklaraten e TVSH-se</td>
                {vat0Columns.map(column => (
                    <td key={column.key} style={{ ...cellStyle, background: column.key === 'K10' ? '#BFBFBF' : undefined }}>{column.box}</td>
                ))}
                {vat18Columns.map(column => (
                    <td key={column.key} style={cellStyle}>{column.box}</td>
                ))}
                <td style={{ ...cellStyle, background: '#BFBFBF' }}>[K1]</td>
                {vat8Columns.map(column => (
                    <td key={column.key} style={cellStyle}>{column.box}</td>
                ))}
                <td style={{ ...cellStyle, background: '#BFBFBF' }}>[K2]</td>
                <td style={{ ...cellStyle, background: '#BFBFBF' }}>[30]</td>
            </tr>
        </tbody>
    );
};

export default AtkSaleBookHeader;
